<template>
  <!-- 警报点控制器信息 -->
  <div>
    <!--      <div class="crumbs">-->
    <!--        <el-breadcrumb separator="/">-->
    <!--          <el-breadcrumb-item>警报点</el-breadcrumb-item>-->
    <!--          <el-breadcrumb-item>警报点控制器信息</el-breadcrumb-item>-->
    <!--        </el-breadcrumb>-->
    <!--      </div>-->
    <el-card class="box-card" style="margin-top: 30px;">
      <div slot="header" class="clearfix">
        <span>警报点控制器信息</span>
        <el-button type="primary" size="medium" style="float: right;" @click="updateInfo()">信息更改
        </el-button>

        <!--          <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
      </div>
      <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
        <div class="tonghang">
          <el-form-item label="生产厂家">
            <span>{{alarmControllerInfo.producer}}</span>
          </el-form-item>
          <el-form-item label="通信体制">
            <span>{{alarmControllerInfo.communicationSystem}}</span>
          </el-form-item>
        </div>

        <div class="tonghang">
          <el-form-item label="版本">
            <span>{{alarmControllerInfo.version}}</span>
          </el-form-item>
          <el-form-item label="地址码">
            <span>{{alarmControllerInfo.addressCode}}</span>
          </el-form-item>
        </div>

        <div class="tonghang">
          <el-form-item label="电台型号">
            <span>{{alarmControllerInfo.radioType}}</span>
          </el-form-item>
          <el-form-item label="安装者">
            <span>{{alarmControllerInfo.installer}}</span>
          </el-form-item>
        </div>

        <div class="tonghang">
          <el-form-item label="安装时间">
            <span><i class="el-icon-time"></i> &nbsp;{{alarmControllerInfo.installAt}}</span>
          </el-form-item>
          <el-form-item label="备注">
            <span>{{alarmControllerInfo.remark}}</span>
          </el-form-item>
        </div>

        <div class="tonghang">
          <el-form-item>
            <!--              <el-button type="primary" size="medium" style="margin-top: 30px;" @click="openAltStaticInformation">信息更改</el-button>-->
          </el-form-item>
        </div>


      </el-form>
    </el-card>
    <el-dialog :visible.sync="updateAlarmControllerVisible" @close="getStaticInfo"
               v-if="updateAlarmControllerVisible">
      <template slot="title">
        <span>修改警报控制器信息</span>

      </template>
      <el-form :label-position="labelPosition" label-width="80px" :model="formAlarmInfo" :ref="formAlarmInfo"
               :rules="rulesOfAltStaticInformation">
        <el-form-item label="生产厂家" prop="producer">
          <el-input v-model="formAlarmInfo.producer"></el-input>
        </el-form-item>
        <el-form-item label="通信体制" prop="communicationSystem">
          <el-input v-model="formAlarmInfo.communicationSystem"></el-input>
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-input v-model="formAlarmInfo.version"
                    oninput="value=value.replace(/[^\d.]/, '')"></el-input>
        </el-form-item>
        <el-form-item label="地址码" prop="addressCode">
          <!--<el-input v-model="AltStaticInformation.params.content.addressCode"></el-input>-->
          <el-select type="number" placeholder="群" v-model="qun" style="width: 150px;" clearable filterable>
            <el-option v-for="item in Array.from(Array(127), (v,k) =>k + 1)" :value="item" :label="item"
                       filterable></el-option>
          </el-select>
          -
          <el-select type="number" placeholder="号" v-model="hao" style="width: 150px;" clearable filterable>
            <el-option v-for="item in Array.from(Array(511), (v,k) =>k + 1)" :value="item" :label="item"
                       filterable></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电台型号" prop="radioType">
          <el-input v-model="formAlarmInfo.radioType"></el-input>
        </el-form-item>
        <el-form-item label="安装人" prop="installer">
          <el-input v-model="formAlarmInfo.installer"></el-input>
        </el-form-item>
        <el-form-item label="安装时间" prop="installAt">
          <el-date-picker v-model="formAlarmInfo.installAt" value-format="yyyy-MM-dd"
                          style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="formAlarmInfo.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateAlarmControllerDialog">取 消</el-button>
        <el-button type="primary" @click="checkAltStaticInformation ()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import AlarmViewNav from './AlarmViewNav'

  export default {
    name: 'AlarmControllerView',
    components: { AlarmViewNav },
    data () {
      return {
        qun: '',
        hao: '',
        alarmControllerInfo: {
          "producer":"",
          "communicationSystem":"",
          "version":"",
          "addressCode":"",
          "radioType":"",
          "installer":"",
          "installAt":"",
          "remark":""
        },
        formAlarmInfo:{
          "producer":"",
          "communicationSystem":"",
          "version":"",
          "addressCode":"",
          "radioType":"",
          "installer":"",
          "installAt":"",
          "remark":""
        },
        rulesOfAltStaticInformation: {
          producer: [{ required: true, message: '生产厂家不能为空', trigger: 'blur' }],
          communicationSystem: [{ required: true, message: '通信体制不能为空', trigger: 'blur' }],
          version: [{ required: true, message: '版本不能为空', trigger: 'blur' }],
          qun: [{ required: true, message: '地址码不能为空', trigger: 'change'}],
          hao: [{ required: true, message: '地址码不能为空', trigger: 'change'}],
          radioType: [{ required: true, message: '电台型号不能为空', trigger: 'blur' }],
          installer: [{ required: true, message: '安装人不能为空', trigger: 'blur' }],
          installAt: [{ required: true, message: '安装时间不能为空', trigger: 'blur' }],
          // remark:[{required: true, message:'备注不能为空', trigger: 'change'}],
        },
        AltStaticInformation: {
          'version': 1,
          'method': 'alarmpoint2.AltStaticInformation',
          'params': {
            'alarmPointId': '',
            'option': 2,
            'content': {
              'producer': '',
              'communicationSystem': '',
              'version': '',
              'addressCode': '',
              'radioType': '',
              'installer': '',
              'installAt': '',
              'remark': '',
            },
          },
          'token': '#',
          'id': 0
        },
        // 查看警报点静态信息
        GetStaticInformation: {
          'version': 1,
          'method': 'alarmpoint2.GetStaticInformation',
          'params': {
            'alarmPointId': '#'
          },
          'token': '#',
          'id': 0
        },
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        // labelPosition:'left',
        updateAlarmControllerVisible: false,
      }
    },
    methods: {
      checkAltStaticInformation () {
        this.$refs[this.AltStaticInformation.params.content].validate((valid) => {
          if (valid) {
            this.altStaticInformation()
          } else {
            return false
          }
        })
      },
      getStaticInfo () {
        this.GetStaticInformation.params.alarmPointId = window.sessionStorage.getItem('alarmPointId')
        for (let key in this.GetStaticInformation.params) {
          if (this.GetStaticInformation.params[key] === '') {
            this.GetStaticInformation.params[key] = null
          }
        }
        this.$axios.post(this.$mainUrl, this.GetStaticInformation).then(res => {
          if (res.data.hasOwnProperty('result')) {
            if(res.data.result.alarmControllerInformation){
              this.alarmControllerInfo = res.data.result.alarmControllerInformation
              if(this.alarmControllerInfo.addressCode==""||this.alarmControllerInfo.addressCode==null){
                this.qun = "";
                this.hao = ""
              }else{
                this.qun = this.alarmControllerInfo.addressCode.split('-')[0];
                this.hao = this.alarmControllerInfo.addressCode.split('-')[1];
              }
            }
            this.formAlarmInfo = this.alarmControllerInfo;


          }
        })
      },
      updateInfo(){
        this.updateAlarmControllerVisible = true;
      },
      altStaticInformation() {
        this.AltStaticInformation.params.alarmPointId = window.sessionStorage.getItem("alarmPointId");
        this.formAlarmInfo.addressCode = this.qun + "-"+this.hao;
        this.AltStaticInformation.params.content = this.formAlarmInfo;
        for (let key in this.AltStaticInformation.params) {
          if (this.AltStaticInformation.params[key] === '') {
            this.AltStaticInformation.params[key] = null
          }
        }
        this.$axios.post(this.$mainUrl,this.AltStaticInformation).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.$message.success("修改成功")
            this.getStaticInfo()
            this.updateAlarmControllerVisible = false;
          }
        })
      },
      closeUpdateAlarmControllerDialog(){
        this.updateAlarmControllerVisible = false;
        this.getStaticInfo()
      }

      // openUpdateAlarmController(){
      //   // this.AltStaticInformation.params.content = this.$store.state.AlarmPointStaticInfomation.result.alarmControllerInformation;
      //   this.AltStaticInformation.params.content = JSON.parse(JSON.stringify(this.alarmControllerInformation));
      //   if(this.AltStaticInformation.params.content.addressCode.indexOf('-') !== -1){
      //     this.qun = /^(.*?)-/g.exec(this.AltStaticInformation.params.content.addressCode)[1];
      //     this.hao = /-(.*?)$/g.exec(this.AltStaticInformation.params.content.addressCode)[1];
      //   }
      //   this.updateAlarmControllerVisible = true;
      // },
      // getAlarmPointStaticInfomation(){
      //   console.log('这是token');
      //   console.log(localStorage.getItem('token'));
      //   this.GetStaticInformation.token = localStorage.getItem('token');
      //   this.GetStaticInformation.params.alarmPointId = window.sessionStorage.getItem("alarmPointId");
      //   console.log('查看警报点静态信息请求');
      //   console.log(this.GetStaticInformation);
      //   this.$axios.post(this.$mainUrl, this.GetStaticInformation).then(res=> {
      //     console.log('查看警报点静态信息请求得到响应');
      //     console.log(res.data);
      //     if(res.data.hasOwnProperty('result')){
      //       this.AltStaticInformation.params.content = res.data.result.alarmControllerInformation
      //       //this.$store.commit('setAlarmPointStaticInfomation', res.data);
      //     }else{
      //       this.$message({
      //         type:'error',
      //         message:'获取警报点静态信息失败，' + res.data.error.message
      //       })
      //     }
      //   })
      // },
      // altStaticInformation(){
      //   this.AltStaticInformation.params.content.addressCode = this.qun + "-"+this.hao;
      //   this.AltStaticInformation.token = localStorage.getItem('token');
      //   this.AltStaticInformation.params.alarmPointId = window.sessionStorage.getItem("alarmPointId");
      //   this.AltStaticInformation.params.content.version = parseFloat(this.AltStaticInformation.params.content.version)
      //   console.log('修改警报点静态信息请求');
      //   console.log(this.AltStaticInformation);
      //   this.$axios.post(this.$mainUrl, this.AltStaticInformation).then(res =>{
      //     console.log('编辑警报点静态信息请求得到响应');
      //     console.log(res.data);
      //     if(res.data.hasOwnProperty('result')){
      //       this.$message({
      //         type: 'success',
      //         message: '编辑警报点静态信息成功'
      //       })
      //       this.closeUpdateAlarmControllerDialog();
      //       this.getAlarmPointStaticInfomation();
      //     }else{
      //       this.$message({
      //         type: 'error',
      //         message: '编辑警报点静态信息失败，' + res.data.error.message
      //       })
      //     }
      //   })
      //
      // },
      // closeUpdateAlarmControllerDialog(){
      //   this.resetValidate(this.AltStaticInformation.params.content);
      //   this.updateAlarmControllerVisible = false;
      // }
    },
    // computed:{
    //   alarmControllerInformation(){
    //     if(this.$store.state.AlarmPointStaticInfomation.result.hasOwnProperty('alarmControllerInformation')){
    //       return this.$store.state.AlarmPointStaticInfomation.result.alarmControllerInformation;
    //     }else{
    //       return {
    //         producer:'', communicationSystem:'', version:'', addressCode:'', radioType:'', installAt:'', installer:'', remark:''
    //       }
    //     }
    //   }
    // },
    mounted () {
      this.getStaticInfo()
      //this.altStaticInformation()
      // this.alarmControllerInformation = this.$store.state.AlarmPointStaticInfomation.result.alarmControllerInformation;
    }
  }
</script>

<style scoped>

</style>
<style>
  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  .tonghang {
    display: flex;
    flex-wrap: nowrap;
  }
</style>
